{
    "ModalTitleAdd": "Neuen Bericht hinzufügen",
    "ModalTitleModify": "Bericht ändern",
    "ModalTitleDateTime": "Datums-\/Zeitbereich",
    "TabnameReport": "Bericht",
    "TabnameFilter": "Filter",
    "TabnameOther": "Sonstiges",
    "TabnameFields": "Felder",
    "TabnameDashboard": "Layout",
    "TabnameSlakpi": "SLA\/KPI",
    "TabnameAlarms": "Alarm",
    "TabnameScheduling": "Planung",
    "TabnameAcdCodes": "Codes",
    "TabnameFinancial": "Finanziell",
    "TabnameSettings": "Einstellungen",
    "TabnamePrint": "Drucken",
    "TabnameAdvanced": "Fortschrittlich",
    "ReporttypelabelNolistitems": "Keine aktuellen Listenelemente mit diesem Namen.",
    "ConfigureReport_ButtonHelpLabel": "Hilfe?",
    "ConfigureReport_ButtonSubmitLabel": "OK",
    "ConfigureReport_ButtonCancelLabel": "Absagen",
    "ConfigureReport_PromptMessage": "Möchten Sie dieses Fenster wirklich schließen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
    "ConfigureReport_PromptConfirm": "Ja",
    "ConfigureReport_PromptCancel": "Absagen",
    "ConfigureReport_Basic": "Grundlegend",
    "ConfigureReport_Advanced": "Fortschrittlich",
    "NAME": "ConfigureReport"
}